// JS constants
const LARGE_WIDTH = 1025;

export function handleSideMenu() {
  if ($(window).outerWidth() < LARGE_WIDTH) {
    $('#sidebar').removeClass('isCollapsed');
  }
}
